$(document).ready( function () {


  var $carousel = $('.carousel').flickity({
    // options
    wrapAround: true,
    autoPlay: false,
    imagesLoaded: true,
    lazyLoad: true
  });  

  $('.block-content-intro a').on( 'click', function() {
  
      $(this).addClass('hide');
      $(this).parent().parent().find('.block-content-description p').show('slow');
  
    
  });    
  
} );

document.addEventListener('DOMContentLoaded', function() {
  // Function to trigger variant selection
  function selectFirstAvailableVariant() {
    // Find all variant option containers
    const variantOptions = document.querySelectorAll('[data-picker-field="radio"]');
    
    variantOptions.forEach(optionContainer => {
      // Find the first available input in each option group
      const firstInput = optionContainer.querySelector('input[type="radio"]');
      
      if (firstInput && !firstInput.checked) {
        // Select the input
        firstInput.checked = true;
        
        // Dispatch change event to update the variant picker
        const event = new Event('change', { bubbles: true });
        firstInput.dispatchEvent(event);
      }
    });
  }

  // Run on page load
  selectFirstAvailableVariant();
  
  // Also run when variant picker is initialized (in case it loads after DOMContentLoaded)
  const variantPicker = document.querySelector('variant-picker');
  if (variantPicker) {
    const observer = new MutationObserver(function(mutations) {
      selectFirstAvailableVariant();
      observer.disconnect(); // Stop observing after first change
    });
    
    observer.observe(variantPicker, { 
      childList: true, 
      subtree: true,
      attributes: true
    });
  }
});